var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ring-left-menu" } },
    [
      _c(
        "el-aside",
        { attrs: { width: "224px" } },
        [
          _c(
            "div",
            { staticClass: "logo" },
            [
              _c("router-link", { attrs: { to: { name: "HomePage" } } }, [
                _c("img", {
                  attrs: { src: require("../../assets/logo-big.png") },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              attrs: {
                mode: "vertical",
                router: true,
                "default-active": _vm.defaultActiveMenuItem,
              },
            },
            _vm._l(_vm.menuItems, function (item) {
              return _c(
                "el-menu-item",
                {
                  key: item.name,
                  attrs: {
                    index: item.index.toString(),
                    route: { name: item.name, params: { id: _vm.customer.id } },
                  },
                },
                [
                  _c("img", { attrs: { src: item.icon } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "indicator" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t(item.i18n)))]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }